import { Trans, useTranslation } from 'react-i18next';

import { Anchor, Body1, Modal } from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';

import externalRoutes from '../../../external-routes';

type PARequiredModalProps = {
    opened: boolean;
    close: () => void;
};

export const PARequiredModal = ({ opened, close }: PARequiredModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            opened={opened}
            onClose={close}
            title={t('common.drugCoverageAlerts.paRequired.modalTitle')}
        >
            <Body1>
                <Trans
                    i18nKey="common.drugCoverageAlerts.paRequired.modalDescriptionOne"
                    components={{
                        1: (
                            <Anchor
                                href={externalRoutes.priorAuthForm}
                                target="_blank"
                            />
                        ),
                    }}
                    values={{ tm: constants.unicode.TRADEMARK }}
                />
            </Body1>
        </Modal>
    );
};
